export const build = { date:"2026-06-27.1015", stage:"alpha" }
